<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Produtos</p>
        </div>

        <div class="muven-content">
            <Loading page v-if="loading" />

            <ConfirmationExclusionModalCmp 
                ref="confirmationExclusionModal"
                @confirm="confirmExclusionHandler" />

            <ProductStoreChannelStatusToggleCmp 
                ref="productStoreChannelStatusToggle" />

            <AuditListQuickVisualizationCmp 
                ref="auditListQuickVisualizationModal" />

            <div class="mb-3 product-toolbar" v-if="!loading">
                <div class="product-toolbar-actions">
                    <button type="button"
                        class="btn btn-primary mr-3"
                        :disabled="openingFilterModal"
                        @click="showFilterModal()">
                        Filtro

                        <Loading v-show="openingFilterModal" />
                    </button>

                    <router-link type="button"
                        class="btn btn-outline-secondary"
                        to="/produtos/lotes">
                        Gerenciamento em lote
                    </router-link>
                </div>

                <div class="product-sort" :class="{'is-loading': loadingFilter}">
                    <label for="product-sort-field">Ordenar por</label>

                    <select id="product-sort-field"
                        :value="sortSelected"
                        :disabled="loadingFilter"
                        @change="changeSort($event.target.value)">
                        <option v-for="sortOption in sortOptions"
                            :key="sortOption.value"
                            :value="sortOption.value">{{sortOption.description}}</option>
                    </select>
                </div>
            </div>

            <FilterInformationCmp 
                v-if="!loading"
                :filter-submitted="productFilterSubmitted"
                :filter-properties="productFilterProperties" />

            <div class="modal" tabindex="-1" role="dialog" id="muven-product-list-filter-modal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Filtro de produtos</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Tipo de filtro</label>
                                    <div class="btn-group">
                                       <button v-for="(filterOption, indexFilterOption) in filterOptions" :key="indexFilterOption"
                                        type="button" 
                                        class="btn btn-outline-secondary"
                                        :class="{active: filterOption.active}"
                                        @click="updateFilterOption(filterOption)">{{filterOption.description}}</button>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="isFilterOptionByBackendInfo">
                                <div class="col-12 form-group">
                                    <label>Id na retaguarda</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="productFilter.idSource" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Código na retaguarda</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="productFilter.codeSource" />
                                </div>
                            </div>

                            <div class="row" v-if="isFilterOptionByChannelInfo">
                                <div class="col-12 form-group">
                                    <label>Id no canal</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="productFilter.idExternalChannel" />
                                </div>
                            </div>

                            <div class="row" v-if="isFilterOptionAdvanced">
                                <div class="col-12 col-md-6 form-group">
                                    <label>Nome</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="productFilter.name" />
                                </div>

                                <div class="col-12 col-md-3 form-group">
                                    <label>Código SKU</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="productFilter.skuCode" />
                                </div>

                                <div class="col-12 col-md-3 form-group">
                                    <label>Código EAN</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="productFilter.eanCode" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Descrição</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="productFilter.description" />
                                </div>

                                <div class="col-12 col-md-8 form-group">
                                    <label>Qualidade</label>
                                    <multiselect
                                        v-model="productFilter.qualityList"
                                        :options="qualityList"
                                        :multiple="true"
                                        :show-labels="false"
                                        label="description"
                                        track-by="enum"
                                        placeholder="" />
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Status</label>
                                    <multiselect
                                        v-model="productFilter.isActive"
                                        :options="isActiveOptions"
                                        :multiple="false"
                                        :show-labels="false"
                                        label="description"
                                        track-by="bool"
                                        placeholder="" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Vinculado às categorias</label>
                                    <multiselect
                                        v-model="productFilter.categoryList"
                                        :options="categoryList"
                                        :multiple="true"
                                        :show-labels="false"
                                        label="name"
                                        track-by="id"
                                        placeholder="" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Vinculado às marcas</label>
                                    <multiselect
                                        v-model="productFilter.brandList"
                                        :options="brandList"
                                        :multiple="true"
                                        :show-labels="false"
                                        label="name"
                                        track-by="id"
                                        placeholder="" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                @click="getProductsWithFilter(productFilter)"
                                :disabled="loadingFilter">
                                    Filtrar
                                    <Loading v-show="loadingFilter" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="clearFilter()">Restaurar</button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeFilterModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <NothingFound v-if="nothingToShow && !loadingFilter" />

            <div class="product-list-results" v-if="!loading && (!nothingToShow || loadingFilter)">
                <div class="product-list-reloading" v-show="loadingFilter">
                    <Loading message="Carregando produtos" />
                </div>

                <div class="table-responsive">
                    <table class="table table-hover table-sm">
                        <thead>
                            <tr>
                                <th class="product-name-width">Nome</th>
                                <th class="product-type-width">Tipo</th>
                                <th>SKU</th>
                                <th>Código retaguarda</th>
                                <th class="status-col">Status</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody v-for="(product, index) in productList" :key="index">
                            <tr class="product-row" @click="openProduct(product, $event)">
                                <td><router-link :to="detailUrl(product)" class="product-name-link">{{product.name}}</router-link></td>
                                <td>
                                    <span v-if="!product.hasChildren()" class="product-type-simple">Simples</span>

                                    <button v-else
                                        type="button"
                                        class="grid-pill"
                                        :class="{'is-open': product.isGridVisible}"
                                        :aria-expanded="product.isGridVisible ? 'true' : 'false'"
                                        :title="variationsTitle(product)"
                                        @click="toggleGridExhibition(product)">
                                        <span class="grid-pill-label">Grade</span>
                                        <span class="grid-pill-count">{{product.getVariationsCount()}}</span>

                                        <fa icon="chevron-down"
                                            class="icon-grid-toggle"
                                            :class="{
                                                'show-grid': product.isGridVisible,
                                            }"
                                        />
                                    </button>
                                </td>
                                <td>{{product.skuCode | infoOrPlaceholder}}</td>
                                <td>{{product.codeSource | infoOrPlaceholder}}</td>
                                <td>
                                    <span v-if="product.isActive">
                                        <span class="muven-td-icon">
                                            <fa icon="check-circle" 
                                                class="text-success" />
                                        </span>

                                        <span>Ativo</span>
                                    </span>

                                    <span v-if="!product.isActive">
                                        <span class="muven-td-icon">
                                            <fa icon="ban" 
                                                class="text-muted" />
                                        </span>

                                        <span>Inativo</span>
                                    </span>

                                </td>
                                <td class="text-center muven-td-with-buttons">
                                    <button type="button"
                                        class="btn btn-default text-muted"
                                        data-toggle="dropdown" >
                                        <fa icon="ellipsis-v" v-show="!product.loadingListAction" />
                                        <fa icon="sync-alt" spin v-show="product.loadingListAction" />
                                    </button>

                                    <div class="dropdown-menu dropdown-menu-right muven-action-menu">
                                        <router-link class="dropdown-item"
                                            :to="detailUrl(product)">
                                            <fa icon="file-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Detalhes</span>
                                        </router-link>

                                        <router-link class="dropdown-item"
                                            :to="modificationUrl(product)">
                                            <fa icon="edit" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Editar</span>
                                        </router-link>

                                        <p class="dropdown-divider" v-show="product.hasChildren()"></p>

                                        <span class="dropdown-item"
                                            @click="toggleGridExhibition(product)"
                                            v-show="product.hasChildren()">
                                            <fa icon="sitemap" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label" v-show="!product.isGridVisible">Exibir variações</span>
                                            <span class="muven-action-label" v-show="product.isGridVisible">Esconder variações</span>
                                        </span>

                                        <p class="dropdown-divider" v-show="!product.hasChildren()"></p>

                                        <a class="dropdown-item"
                                            :href="urlToOrder(product)"
                                            v-show="!product.hasChildren()"
                                            target="_blank"
                                            rel="noopener"
                                            title="Abre em uma nova aba">
                                            <fa icon="clipboard-list" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Pedidos com este produto</span>
                                            <fa icon="external-link-alt" class="muven-action-external" />
                                        </a>

                                        <p class="dropdown-divider" v-show="showProductChannelStatusManagement"></p>

                                        <span class="dropdown-item"
                                            v-show="showProductChannelStatusManagement"
                                            @click="openProductStoreChannelStatusToggle(product)">
                                            <fa icon="store-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Gerenciar envio por canal</span>
                                        </span>

                                        <p class="dropdown-divider"></p>

                                        <span class="dropdown-item"
                                            @click="forceChannelsSync(product)">
                                            <fa icon="sync-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Forçar sincronização</span>
                                        </span>

                                        <p class="dropdown-divider" v-show="!subscriber.isBackendBimer()"></p>

                                        <span class="dropdown-item muven-action-danger"
                                            v-show="!subscriber.isBackendBimer()"
                                            @click="openConfirmationExclusionModal(product)">
                                            <fa icon="trash-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Excluir produto</span>
                                        </span>

                                        <p class="dropdown-divider"></p>

                                        <span class="dropdown-item"
                                            @click="showAuditQuickVisualization(product)">
                                            <fa icon="search" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Auditoria rápida</span>
                                        </span>

                                        <a class="dropdown-item"
                                            :href="getAuditUrl(productAuditId(product), EntityEnum.Product)"
                                            target="_blank"
                                            rel="noopener"
                                            title="Abre em uma nova aba">
                                            <fa icon="history" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Ir para auditoria</span>
                                            <fa icon="external-link-alt" class="muven-action-external" />
                                        </a>
                                    </div>
                                </td>
                            </tr>

                            <tr class="product-row product-child" v-for="(child, index) in product.children" :key="index" v-show="product.isGridVisible"
                                @click="openProduct(product, $event)">
                                <td>{{child.getVariationsStringified()}}</td>
                                <td>Filho</td>
                                <td>{{child.skuCode | infoOrPlaceholder}}</td>
                                <td>{{child.codeSource | infoOrPlaceholder}}</td>
                                <td>
                                    <span v-if="child.isActive">
                                        <span class="muven-td-icon">
                                            <fa icon="check-circle" 
                                                class="text-success" />
                                        </span>

                                        <span>Ativo</span>
                                    </span>

                                    <span v-if="!child.isActive">
                                        <span class="muven-td-icon">
                                            <fa icon="ban" 
                                                class="text-muted" />
                                        </span>

                                        <span>Inativo</span>
                                    </span>

                                </td>
                                <td class="text-center muven-td-with-buttons">
                                    <button type="button"
                                        class="btn btn-default text-muted"
                                        data-toggle="dropdown" >
                                        <fa icon="ellipsis-v" />
                                    </button>

                                    <div class="dropdown-menu dropdown-menu-right muven-action-menu">
                                        <router-link class="dropdown-item"
                                            :to="detailUrl(product)">
                                            <fa icon="file-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Detalhes</span>
                                        </router-link>

                                        <router-link class="dropdown-item"
                                            :to="modificationUrl(product)">
                                            <fa icon="edit" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Editar</span>
                                        </router-link>

                                        <p class="dropdown-divider"></p>

                                        <a class="dropdown-item"
                                            :href="urlToOrder(child)"
                                            target="_blank"
                                            rel="noopener"
                                            title="Abre em uma nova aba">
                                            <fa icon="clipboard-list" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Pedidos com este produto</span>
                                            <fa icon="external-link-alt" class="muven-action-external" />
                                        </a>

                                        <p class="dropdown-divider"></p>

                                        <span class="dropdown-item"
                                            @click="openProductStoreChannelStatusToggle(product)">
                                            <fa icon="store-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Gerenciar envio por canal</span>
                                        </span>

                                        <p class="dropdown-divider"></p>

                                        <span class="dropdown-item"
                                            @click="forceChannelsSync(product)">
                                            <fa icon="sync-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Forçar sincronização</span>
                                        </span>

                                        <p class="dropdown-divider"></p>

                                        <span class="dropdown-item muven-action-danger"
                                            @click="openConfirmationExclusionModal(child)">
                                            <fa icon="trash-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Excluir produto</span>
                                        </span>

                                        <p class="dropdown-divider"></p>

                                        <span class="dropdown-item"
                                            @click="showAuditQuickVisualization(child)">
                                            <fa icon="search" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Auditoria rápida</span>
                                        </span>

                                        <a class="dropdown-item"
                                            :href="getAuditUrl(child.id, EntityEnum.Product)"
                                            target="_blank"
                                            rel="noopener"
                                            title="Abre em uma nova aba">
                                            <fa icon="history" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Ir para auditoria</span>
                                            <fa icon="external-link-alt" class="muven-action-external" />
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <ListCount :amount="productList.length" />
                </div>

                <div v-if="showPaginationButton" class="text-center">
                    <button class="btn btn-outline-secondary"
                        @click="getMoreProducts()"
                        :disabled="loadingNextPage">
                        <span v-show="!loadingNextPage">Mais resultados</span>
                        <fa v-show="loadingNextPage" icon="sync-alt" spin/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import {cloneDeep} from 'lodash'
import productService from '@/product/services/ProductService'
import { PaginationModel } from '@/utils/models/PaginationModel'
import { ProductListFilterModel } from '@/product/models/ProductListFilterModel'
import { dateTimeFilter } from '@/utils/filters/DateTimeFilter'
import modalService from '@/utils/services/ModalService'
import FilterInformationCmp from '@/utils/components/FilterInformationCmp'
import { EntityEnum } from '@c2b/muven-commons'
import GetAuditUrl from '@/utils/mixins/GetAuditUrl'
import {infoOrPlaceholder} from '@/utils/filters/InformationOrPlaceholderFilter'
import channelService from '../../channel/services/ChannelService'
import categoryService from '../../category/services/CategoryService'
import brandService from '../../brand/services/BrandService'
import ConfirmationExclusionModalCmp from '@/utils/components/ConfirmationExclusionModalCmp'
import { flattenTree } from '@/utils/normalizers/TreeNormalizer'
import { ProductModel } from '../models/ProductModel'
import ProductStoreChannelStatusToggleCmp from '../components/ProductStoreChannelStatusToggleCmp'
import AuditListQuickVisualizationCmp from '@/audit/components/AuditListQuickVisualizationCmp'
import productListPreferencesManager from '../managers/ProductListPreferencesManager'

const ID_FILTER_MODAL = '#muven-product-list-filter-modal'
const FILTER_BY_BACKEND_INFO = 'filter_by_backend_info'
const FILTER_BY_CHANNEL_INFO = 'filter_by_channel_info'
const FILTER_ADVANCED = 'filter_advanced'

export default {
    name: 'ProductListView',    
    data() {
        return {
            EntityEnum,
            canCreateProduct: false,
            loading: true,
            loadingFilter: false,
            openingFilterModal: false,
            pagination: new PaginationModel(),
            showPaginationButton: true,
            loadingNextPage: false,
            sort: productListPreferencesManager.getSort(),
            sortOptions: [
                {
                    value: 'id:desc',
                    description: 'Mais recentes primeiro',
                },
                {
                    value: 'id:asc',
                    description: 'Mais antigos primeiro',
                },
            ],
            productFilter: new ProductListFilterModel(),
            productFilterSubmitted: new ProductListFilterModel(),
            paginationSessionId: '',
            channelList: [],
            productList: [],
            categoryList: [],
            brandList: [],
            qualityList: ProductListFilterModel.getQualityList(),
            isActiveOptions: [
                {
                    bool: true,
                    description: 'Ativo',
                },
                {
                    bool: false,
                    description: 'Inativo',
                },
            ],
            filterOptions: [
                {
                    enum: FILTER_ADVANCED,
                    description: 'Geral',
                    active: true,
                },
                {
                    enum: FILTER_BY_BACKEND_INFO,
                    description: 'Retaguarda',
                    active: false,
                },
                {
                    enum: FILTER_BY_CHANNEL_INFO,
                    description: 'Canal',
                    active: false,
                },
            ],
            filterOptionSelected: {
                enum: FILTER_ADVANCED,
                description: 'Geral',
                active: true,
            },
            productFilterProperties: [
                {
                    type: 'string',
                    label: 'Nome',
                    property: 'name',
                },
                {
                    type: 'booleanwrapped',
                    label: 'Status',
                    property: 'isActive',
                },
                {
                    type: 'string',
                    label: 'SKU',
                    property: 'skuCode',
                },
                {
                    type: 'string',
                    label: 'EAN',
                    property: 'eanCode',
                },
                {
                    type: 'string',
                    label: 'Descrição',
                    property: 'description',
                },
                {
                    type: 'string',
                    label: 'Id na retaguarda',
                    property: 'idSource',
                },
                {
                    type: 'string',
                    label: 'Código na retaguarda',
                    property: 'codeSource',
                },
                {
                    type: 'string',
                    label: 'Id no canal',
                    property: 'idExternalChannel',
                },
                {
                    type: 'list',
                    label: 'Categorias',
                    property: 'categoryList',
                    propertyInList: 'name',
                },
                {
                    type: 'list',
                    label: 'Marcas',
                    property: 'brandList',
                    propertyInList: 'name',
                },
                {
                    type: 'list',
                    label: 'Qualidade',
                    property: 'qualityList',
                    propertyInList: 'description',
                },
            ],
        }
    },
    mixins: [
        GetAuditUrl,
    ],
    filters: {
        dateTimeFilter,
        infoOrPlaceholder,
    },
    components: {
        FilterInformationCmp,
        ConfirmationExclusionModalCmp,
        ProductStoreChannelStatusToggleCmp,
        AuditListQuickVisualizationCmp,
    },
    methods: {
        // A linha toda (pai ou variação) leva ao detalhe do produto, menos quando o clique
        // foi num controle dela (pílula da grade, menu, link) ou a pessoa selecionava texto.
        openProduct(product, event) {
            if (event && event.target && event.target.closest && event.target.closest('a, button, .dropdown-menu, .muven-td-with-buttons')) {
                return
            }

            const selection = window.getSelection && window.getSelection()

            if (selection && selection.toString()) {
                return
            }

            this.$router.push(this.detailUrl(product))
        },
        paginationOptions() {
            return {
                page: this.pagination.actual(),
                sessionId: this.paginationSessionId,
                sort: this.sort.field,
                order: this.sort.order,
            }
        },
        changeSort(value) {
            const [field, order] = String(value).split(':')

            this.sort = {field, order}
            productListPreferencesManager.setSort(this.sort)

            // O sessionId aponta para a lista acumulada no Redis com a ordem anterior;
            // reaproveita-lo aqui misturaria as duas ordenacoes no mesmo array.
            this.paginationSessionId = ''

            return this.getProductsWithFilter(this.productFilterSubmitted)
        },
        async getMoreProducts() {
            try {
                this.loadingNextPage = true
                const newProductListWrapped = await productService.getProducts(
                    this.paginationOptions(), this.productFilter)

                this.productList = []

                this.productList = newProductListWrapped.result.map((prod) => {
                    return ProductModel.normalizeV1(prod, this.subscriber)
                })

                if (this.pagination.actual() === newProductListWrapped.page) {
                    this.showPaginationButton = false
                }

                this.paginationSessionId = newProductListWrapped.sessionId
                this.pagination.update(newProductListWrapped.page)
            } catch(e) {
                this.$floatingAlert.error({
                    message: e.message,
                })
            }

            this.loadingNextPage = false
        },
        async getProductsWithFilter(filterList) {
            this.showPaginationButton = true
            this.productFilterSubmitted = cloneDeep(filterList)
            this.pagination.reset()
            this.loadingFilter = true
            try {
                const productListWrapped = await productService.getProducts(
                    this.paginationOptions(), filterList)

                this.productList = []

                this.productList = productListWrapped.result.map((prod) => {
                    return ProductModel.normalizeV1(prod, this.subscriber)
                })

                this.closeFilterModal()

                this.paginationSessionId = productListWrapped.sessionId
                this.pagination.update(productListWrapped.page)
            } catch (e) {
                this.$floatingAlert.error({
                    message: e.message,
                })
            }

            this.loadingFilter = false
        },
        updateFilterOption(filterOption) {
            this.filterOptions.forEach((fo) => {
                fo.active = false
            })

            this.filterOptionSelected = Object.assign(filterOption, {active: true})            
            this.clearFilter()
        },
        async showFilterModal() {
            this.openingFilterModal = true

            try {
                if (!this.categoryList.length || !this.brandList.length) {
                    const result = await Promise.all([
                        categoryService.getCategoryTree(),
                        brandService.getAllBrands(),
                    ])

                    this.categoryList = flattenTree(result[0])
                    this.brandList = result[1]
                }

                await modalService.show(ID_FILTER_MODAL)
            } catch(err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.openingFilterModal = false
        },
        async closeFilterModal() {
            await modalService.hide(ID_FILTER_MODAL)
        },
        clearFilter() {
            this.productFilter = new ProductListFilterModel()
        },
        goto(product) {
            this.$router.push(`/produtos/${product.id}`);
        },
        gotoModification(product) {
            this.$router.push(`/produtos/${product.id}/edicao`);
        },
        openConfirmationExclusionModal(product) {
            const info = {
                id: product.id,
                title: 'Exclusão de produto',
                message: `Tem certeza que deseja excluir o produto <span style="font-weight: 600; color: var(--text-soft); text-transform: uppercase; letter-spacing: 1px;">${product.name}</span>?`,
            }

            this.$refs.confirmationExclusionModal.open(info)
        },
        async openProductStoreChannelStatusToggle(product) {
            product.loadingListAction = true

            try {
                await this.$refs.productStoreChannelStatusToggle.openModal(product)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            product.loadingListAction = false           
        },
        async forceChannelsSync(product) {
            product.loadingListAction = true

            try {
                await productService.forceChannelsSync(product.id)
                this.$floatingAlert.info({
                    message: `Solicitação de sincronização do produto <b>${product.name}</b> registrado com sucesso.`,
                    timeVisible: 10000,
                })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message || `Houve um problema no momento de forçar a sincronização do produto <b>${product.name}</b>. Tente novamente mais tarde.`  
                })
            }

            product.loadingListAction = false
        },
        async confirmExclusionHandler({id}) {
            try {
                await productService.deleteProduct(id)

                for (let i = 0; i < this.productList.length; i++) {
                    if (this.productList[i].id === id) {
                        this.$floatingAlert.success({
                            message: `Produto <span style="font-weight: 600; color: var(--text-soft); text-transform: uppercase; letter-spacing: 1px;">${this.productList[i].name}</span> excluído com sucesso.`,
                        })
                        this.productList.splice(i, 1)
                        break
                    }
                }
            } catch (e) {
                this.$floatingAlert.error({
                    message: e.message,
                })
            }

            this.$refs.confirmationExclusionModal.close()
        },
        toggleGridExhibition(product) {
            product.isGridVisible = !product.isGridVisible
        },
        variationsTitle(product) {
            const count = product.getVariationsCount()
            const label = count === 1 ? 'variação' : 'variações'
            const action = product.isGridVisible ? 'Esconder' : 'Exibir'

            return `${count} ${label}. Clique para ${action.toLowerCase()}.`
        },
        async showAuditQuickVisualization(product) {
            product.loadingListAction = true

            let description = `Produto: ${product.name}`

            if (!!product.getVariationsStringified()) {
                description += ` (${product.getVariationsStringified()})`
            }

            let productId = null

            if (product.hasParent()) {            
                productId = product.id
            } else {
                if (!this.subscriber.isBackendBimer() || (this.subscriber.isBackendBimer() && product.hasMoreThanOneChildren())) {
                    productId = product.id
                }

                if (this.subscriber.isBackendBimer() && !product.hasMoreThanOneChildren()) {
                    productId = product.firstChildId
                } 
            }

            await this.$refs.auditListQuickVisualizationModal.showModal({
                idEntity: productId,
                entityList: EntityEnum.Product,
                getDescription: () => `${description}`,
            });

            product.loadingListAction = false
        },
    },
    async mounted() {
        try {
            this.channelList = await channelService.getChannels()

            if (this.$route.query.withCategory) {
                const categoryFromServer = await categoryService.getCategoryById(this.$route.query.withCategory)
                this.productFilter.addToCategoryList(categoryFromServer)
                this.productFilterSubmitted = cloneDeep(this.productFilter)
            }

            if (this.$route.query.withBrand) {
                const brandFromServer = await brandService.getBrandById(this.$route.query.withBrand)
                this.productFilter.addToBrandList(brandFromServer)
                this.productFilterSubmitted = cloneDeep(this.productFilter)
            }

            const productListWrapped = await productService.getProducts(
                this.paginationOptions(), this.productFilter)

            this.productList = []

            this.productList = productListWrapped.result.map((prod) => {
                return ProductModel.normalizeV1(prod, this.subscriber)
            })

            this.paginationSessionId = productListWrapped.sessionId
            this.pagination.update(productListWrapped.page)
        } catch(e) {
            this.$floatingAlert.error({
                message: e.message,
            })
        }

        this.loading = false
    }, 
    computed: {
        ...mapState({
            subscriber: state => state.subscriber,
        }),
        ...mapGetters([
            'hasMoreThanOneStore',
        ]),
        nothingToShow() {
            return !this.loading && !this.productList.length
        },
        sortSelected() {
            return `${this.sort.field}:${this.sort.order}`
        },
        isFilterOptionByBackendInfo() {
            return this.filterOptionSelected.enum === FILTER_BY_BACKEND_INFO
        },
        isFilterOptionByChannelInfo() {
            return this.filterOptionSelected.enum === FILTER_BY_CHANNEL_INFO
        },
        isFilterOptionAdvanced() {
            return this.filterOptionSelected.enum === FILTER_ADVANCED
        },
        detailUrl() {
            return (product) => {
                return `/produtos/${product.id}`
            }
        },
        urlToOrder() {
            return (product) => {
                if (!product.hasParent() && !this.subscriber.isBackendBimer()) {
                    return `/pedidos?custom=true&productIdList=${product.id}`
                }

                if (product.hasParent() && !this.subscriber.isBackendBimer()) {
                    return `/pedidos?custom=true&productIdList=${product.id}`
                }
                
                if (product.hasParent() && this.subscriber.isBackendBimer()) {
                    return `/pedidos?custom=true&productIdList=${product.id}`
                }

                return `/pedidos?custom=true&productIdList=${product.firstChildId}`
            }
        },
        modificationUrl() {
            return (product) => {
                return `/produtos/${product.id}/edicao`
            }
        },
        hasAnyProductWithVariations() {
            return !!this.productList.find((prod) => {
                return prod.hasChildren()
            })
        },
        productAuditId() {
            return (product) => {
                if (!(product instanceof ProductModel)) {
                    return undefined
                }

                if (!this.subscriber.isBackendBimer()) {
                    return product.id
                }

                if (this.subscriber.isBackendBimer() && product.hasMoreThanOneChildren()) {
                    return product.id
                }

                return product.firstChildId
            }
        },
        showProductChannelStatusManagement() {
            return !!this.channelList.find((c) => {
                return c.isTray() || c.isB2W() || c.isNuvemShop() || c.isWooCommerce()
            })
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../utils/styles/constants.scss';

// Tons derivados do roxo da marca, para a pilula conversar com o resto do sistema.
$grid-pill-bg: var(--tint-brand-hover);
$grid-pill-border: var(--tint-brand-border);
$grid-pill-text: var(--brand);

/*
 * Recarga da lista (troca de ordenacao ou de filtro): a tabela antiga continua no lugar,
 * velada por um overlay com spinner. Sem isso a troca de ordenacao demora o suficiente
 * para parecer que nada aconteceu - o unico feedback de loadingFilter que existia era o
 * spinner do botao dentro do modal de filtro, invisivel quando o modal esta fechado.
 */
.product-list-results {
    position: relative;
}

.product-list-reloading {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 5;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 70px;
    background-color: color-mix(in srgb, var(--surface-1) 80%, transparent);

    // raiz do LoadingCmp - herda o scope id desta view por ser o no raiz do filho
    .muven-loading {
        // acompanha o scroll em listas longas, sem sair da area da lista
        position: sticky;
        top: 120px;
        // chip solido: sem fundo proprio o texto se mistura com a tabela velada atras
        padding: 10px 20px;
        background-color: var(--surface-1);
        border: 1px solid var(--border);
        border-radius: 2px;
        box-shadow: 0 2px 8px color-mix(in srgb, var(--shadow-ink) 8%, transparent);
        color: var(--text-muted);
        font-size: .85em;
        font-weight: 600;
        letter-spacing: .5px;
        text-transform: uppercase;
        white-space: nowrap;
    }
}

/*
 * Toolbar da listagem: acoes a esquerda, ordenacao ancorada na borda direita da tabela.
 * O controle de ordenacao e um bloco unico (caption + select fundidos numa mesma
 * moldura) para nao ficar solto ao lado dos botoes - ele pertence a tabela abaixo,
 * entao repete a borda (#dee2e6) e o raio de 2px dela.
 */
.product-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
}

.product-toolbar-actions {
    display: flex;
    align-items: center;
}

.product-sort {
    display: flex;
    align-items: stretch;
    // mantem o bloco ancorado a direita mesmo quando a toolbar quebra em duas linhas
    margin-left: auto;
    border: 1px solid var(--border);
    border-radius: 2px;
    background-color: var(--surface-1);
    overflow: hidden;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;

    &:hover {
        border-color: var(--tint-brand-border);
    }

    &:focus-within {
        border-color: var(--brand-soft);
        box-shadow: 0 0 0 2px color-mix(in srgb, var(--brand-soft) 12%, transparent);
    }

    &.is-loading {
        opacity: .6;
    }

    label {
        display: flex;
        align-items: center;
        margin-bottom: 0;
        padding: 0 12px;
        background-color: var(--surface-2);
        border-right: 1px solid var(--border);
        color: var(--text-muted);
        font-size: .8em;
        font-weight: 600;
        letter-spacing: .5px;
        text-transform: uppercase;
        white-space: nowrap;
        cursor: pointer;
    }

    select {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        height: 34px;
        max-width: 220px;
        padding: 0 30px 0 12px;
        border: 0;
        background-color: transparent;
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 6'%3E%3Cpath fill='%23777' d='M0 0h10L5 6z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 12px center;
        background-size: 9px 6px;
        color: var(--text-soft);
        font-size: .95em;
        font-weight: 500;
        cursor: pointer;
        text-overflow: ellipsis;

        &:focus {
            outline: 0;
        }

        &:disabled {
            cursor: default;
        }
    }

    &:hover select,
    &:focus-within select {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 6'%3E%3Cpath fill='%239C459D' d='M0 0h10L5 6z'/%3E%3C/svg%3E");
    }
}

.product-attributes {
    color: var(--text-muted);
    font-size: .85em;
}

// A linha inteira abre o detalhe.
.product-row {
    cursor: pointer;
}

// O nome é o link "de verdade" da linha (teclado e abrir em nova aba): cor de texto, sublinhado só no hover.
.product-name-link {
    color: var(--text);

    &:hover,
    &:focus-visible {
        color: var(--brand);
        text-decoration: underline;
        text-underline-offset: 3px;
    }
}

.product-child {
    td {
        &:first-of-type {
            padding-left: 54px;
        }

        .grid-info {
            color: var(--text-muted);
            font-size: .9em;
        }
    }
}

.table {
    thead {
        tr {
            th.product-name-width {
                width: 450px;
            }

            th.product-type-width {
                width: 140px;
            }

        }
    }

    tbody {
        tr td {
            .icon-grid-toggle {
                cursor: pointer;
                font-size: .75em;
                color: var(--text-muted);
                transition: transform .3s ease;

                &.show-grid {
                    transform: rotate(180deg);
                }
            }

            // Produto simples: pilula neutra, mesma forma e altura da de grade para a
            // coluna ficar alinhada. A grade continua se destacando pela cor e pela
            // contagem; o simples so precisa ser legivel.
            .product-type-simple {
                display: inline-flex;
                align-items: center;
                padding: 2px 10px;
                border: 1px solid var(--border);
                border-radius: 12px;
                background-color: var(--surface-2);
                color: var(--text-soft);
                font-size: .85em;
                font-weight: 600;
                letter-spacing: .3px;
                line-height: 1.7;
            }

            .grid-pill {
                position: relative;
                display: inline-flex;
                align-items: center;
                padding: 2px 9px 2px 10px;
                border: 1px solid $grid-pill-border;
                border-radius: 12px;
                background-color: $grid-pill-bg;
                color: $grid-pill-text;
                font-size: .85em;
                line-height: 1.7;
                cursor: pointer;
                appearance: none;
                transition: background-color .15s ease, border-color .15s ease, color .15s ease;

                &:hover {
                    background-color: color-mix(in srgb, var(--brand) 6%, #{$grid-pill-bg});
                    border-color: color-mix(in srgb, var(--brand) 14%, #{$grid-pill-border});
                }

                &:focus {
                    outline: 2px solid color-mix(in srgb, var(--brand) 35%, transparent);
                    outline-offset: 1px;
                }

                .grid-pill-label {
                    font-weight: 600;
                    letter-spacing: .3px;
                }

                .grid-pill-count {
                    margin-left: 8px;
                    padding-left: 8px;
                    min-width: 24px;
                    border-left: 1px solid $grid-pill-border;
                    font-weight: 700;
                    // Mantem os digitos alinhados de uma linha para a outra.
                    font-variant-numeric: tabular-nums;
                    text-align: center;
                    transition: border-color .15s ease;
                }

                .icon-grid-toggle {
                    margin-left: 7px;
                    color: inherit;
                }

                &.is-open {
                    background-color: var(--brand-fill);
                    border-color: var(--brand-fill);
                    color: var(--text-on-brand);

                    .grid-pill-count {
                        border-left-color: color-mix(in srgb, var(--white) 40%, transparent);
                    }

                    // Filete descendo em direcao as variacoes, que ja sao
                    // indentadas logo abaixo.
                    &::after {
                        content: '';
                        position: absolute;
                        left: 14px;
                        top: 100%;
                        width: 2px;
                        height: 12px;
                        background-color: color-mix(in srgb, var(--brand) 25%, transparent);
                    }
                }
            }
        }

        &:last-of-type tr {
            border-bottom: 1px solid var(--border);
        }

        &:nth-of-type(odd) tr {
            background-color: color-mix(in srgb, var(--text-strong) 5%, transparent); 

            &:hover {
                background-color: var(--surface-2);
            }
        }
    }
}
</style>
